import { useEffect } from 'react'
import { WOW } from 'wowjs'
import { Container, Row, Col, Image } from 'react-bootstrap'
import './nftbanking.css'

const NFTBanking = () => {
  useEffect(() => {
    new WOW({
      mobile: false,
      live: false,
    }).init()
  }, [])
  return (
    <section className="nftbanking-section position-relative">
      <div className="pink-shape-wrapper">
        <Image
          className="pink-shape position-absolute"
          src="./img/pink-shape.png"
        />
      </div>
      <Container>
        <Row>
          <Col md={12}>
            <div className="rnm-token-used-content">
              <div className="nftr-text-box wow fadeInUp">
                <h2>
                  NFT <strong>BANKING</strong>
                </h2>
                <Image className="pink-bar" src="./img/pink-bar.png" />
                <p>
                  Since NFTs are becoming our web3 identities, it only makes
                  sense to be able to send ETH and ERC20s between them.
                  <br />
                  <br />
                  Our NFT Banking contract allows uploading funds into an NFT,
                  and sending funds from one NFT to another. The funds travel
                  with the NFT wherever it goes.
                  <br />
                  <br />
                  We deployed the{' '}
                  <a
                    href="https://etherscan.io/address/0xc54a8975824f2a9f8ae120a2615580484f25da3a"
                    target="_blank"
                    style={{ textDecoration: 'none' }}
                  >
                    NFTBank contract
                  </a>{' '}
                  100% trustless and decentralized so any platform can leverage
                  it as a new primitive. NFTR will provide a UI so that you can
                  send funds to NFTs by referring to its name.
                </p>
              </div>
              <div className="nftbanking-thumbnail-wrapper">
                <Image
                  className="nftbanking-thumbnail wow fadeInRight"
                  src="./img/rnm-token-used.png"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default NFTBanking
